import styled from "@emotion/styled";
import { PRIMARY_BLACK } from "src/constants/colors";

export const Container = styled.div`
  margin: 24px 0px 24px 0px;
  width: 100%;
  max-width: 781px;
`;

export const Divider = styled.div`
  border-bottom: 1px solid rgba(228, 231, 236, 1);
  margin: 16px 0px;
`;

export const OverviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.div`
  color: ${PRIMARY_BLACK};
  display: flex;
  flex-direction: column;
  gap: 17px;
  font-size: 28px;
  font-weight: 600;
`;
